<template>
    <div class="form-group">
        <label class="control-label">
            {{ l('PAYMENT.BANK_ACCOUNT_NAME') }}
        </label>
        <div class="form-group__input">
            <input ref="firstNameInput"
                   v-model="internalValue.accountHolderFirstName"
                   data-testid="bank-account-first-name-input"
                   type="text"
                   class="form-control input-lg input-first-name"
                   :placeholder="l('PAYMENT.BANK_ACCOUNT_FIRST_NAME')"
                   autocomplete="no-auto-fill" />
            <input v-model="internalValue.accountHolderLastName"
                   data-testid="bank-account-last-name-input"
                   type="text"
                   class="form-control input-lg input-last-name"
                   :placeholder="l('PAYMENT.BANK_ACCOUNT_LAST_NAME')"
                   autocomplete="no-auto-fill" />
        </div>
    </div>

    <div class="form-group">
        <label class="control-label">
            {{ l('CUSTOMER_DETAILS.EMAIL') }}
        </label>
        <div class="form-group__input">
            <input ref="emailInput"
                   v-model="internalValue.accountHolderEmail"
                   data-testid="bank-account-email-input"
                   type="text"
                   class="form-control input-lg input-email"
                   :placeholder="l('CUSTOMER_DETAILS.EMAIL')"
                   autocomplete="no-auto-fill" />
        </div>
    </div>

    <div class="form-group">
        <label class="control-label">
            {{ l('PAYMENT.BANK_ACCOUNT_NUMBER') }}
        </label>
        <div class="form-group__input">
            <input v-model="internalValue.accountNumber"
                   data-testid="bank-account-number-input"
                   type="text"
                   class="form-control input-lg"
                   :placeholder="l('PAYMENT.BANK_ACCOUNT_NUMBER')"
                   autocomplete="no-auto-fill" />
        </div>
    </div>

    <div class="form-group">
        <label class="control-label">
            {{ l('PAYMENT.BANK_ACCOUNT_SORT_CODE') }}
        </label>
        <div class="form-group__input">
            <SortCodeInput v-model="internalValue.branchCode" />
        </div>
    </div>
</template>

<script>
import BankAccount from '@/lib/PaymentMethods/GoCardless/BankAccount';
import SortCodeInput from './SortCodeInput';
import { autoFocus } from '@/vue/directives/autoFocus';

export default {
    components: {
        SortCodeInput,
    },

    directives: {
        autoFocus,
    },

    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            internalValue: new BankAccount(),
        };
    },

    watch: {
        internalValue: {
            handler(newValue) {
                this.$emit('update:modelValue', newValue);
            },
            deep: true,
        },

        modelValue: {
            handler(newValue) {
                Object.assign(this.internalValue, newValue);
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
